import React from 'react';
import CustomFieldTypes from '@/constants/customFields/CustomFieldTypes';
import type CustomField from '@/types/api/CustomField';
import CustomFieldCheckbox from './CustomFields/CustomFieldCheckbox';
import CustomFieldDate from './CustomFields/CustomFieldDate';
import CustomFieldSelect from './CustomFields/CustomFieldSelect';
import CustomFieldText from './CustomFields/CustomFieldText';

function CustomFieldInput({
  error,
  ...field
}: CustomField & { error: boolean }) {
  const { fieldType } = field;
  switch (fieldType) {
    case CustomFieldTypes.CHECKBOX:
      return <CustomFieldCheckbox error={error} {...field} />;
    case CustomFieldTypes.DATE_PICKER:
      return <CustomFieldDate error={error} {...field} />;
    case CustomFieldTypes.LIST_SINGLE:
      return <CustomFieldSelect error={error} field={field} />;
    case CustomFieldTypes.LIST_MULTI:
      return <CustomFieldSelect error={error} field={field} multiple />;
    case CustomFieldTypes.TEXT_SINGLE:
      return <CustomFieldText error={error} field={field} />;
    case CustomFieldTypes.TEXT_MULTI:
      return (
        <CustomFieldText error={error} field={field} multiline minRows={3} />
      );
    default:
      return null;
  }
}

export default CustomFieldInput;
